import { useContext, useMemo } from 'react';
import { AnalyticsContext } from './AnalyticsContext';

export function useAnalytics() {
  const ctx = useContext(AnalyticsContext);
  if (!ctx) {
    throw new Error('useAnalytics must be used within AnalyticsProvider');
  }
  // Memoize so consumers can safely list these in useEffect deps without
  // triggering re-runs on every render (.bind returns a new function each call).
  return useMemo(
    () => ({
      track: ctx.provider.track.bind(ctx.provider),
      identify: ctx.provider.identify.bind(ctx.provider),
      reset: ctx.provider.reset.bind(ctx.provider),
      pageView: ctx.provider.pageView.bind(ctx.provider),
    }),
    [ctx.provider],
  );
}
